import { inject, Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { StorageService } from '@services/storage.service';

@Injectable({
  providedIn: 'root',
})
export class BetterLabGuard implements CanActivate {
  private router = inject(Router);
  private storageService = inject(StorageService);

  /**
   * Determines if the better lab page should be loaded.
   */
  public canActivate(): boolean {
    if (!!this.storageService.transactionId && this.storageService.addressComplete && this.storageService.betterLab) {
      return true;
    }

    this.router.navigate(['order-address.php']);

    return false;
  }
}
